import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const QuizIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z" />
    <circle cx="4" cy="7" r="1.5" />
    <circle cx="4" cy="12" r="1.5" />
    <circle cx="4" cy="17" r="1.5" />
  </SvgIcon>
);

export default QuizIcon;
